import { render, staticRenderFns } from "./futureRisksComponent.vue?vue&type=template&id=14003934"
import script from "./futureRisksComponent.vue?vue&type=script&lang=js"
export * from "./futureRisksComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports